import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';

@Component({
    selector: 'file-selector',
    templateUrl: 'fileSelector.component.html',
    styleUrls: ['fileSelector.component.scss'],
    providers: [{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileSelectorComponent),
      multi: true
    }, {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FileSelectorComponent),
      multi: true
    }]
})

export class FileSelectorComponent implements ControlValueAccessor, Validator {
    private readonly byteToMo = 1048576;
    private propagateValidatorChanged = () => { };
    private disabled: boolean;

    @Input()
    public acceptedFileTypes: string[];

    @Input()
    public maxSize: number;

    private _file: File;
    @Input()
    get file() { return this._file; }
    set file(val) { this._file = val; }

    public isDragging: boolean;

    public get isFileValid() { return this.file !== undefined; }

    // Emits when the upload
    @Output() public upload = new EventEmitter();

    // Emits when the selected file changed but it exceeds the limit
    @Output() public maxSizeExceeded = new EventEmitter();

    // Emits when the selected file changed but the type is invalid
    @Output() public fileTypeInvalid = new EventEmitter();

    public onFileChange(event) {
        if (event.target.files.length === 0) return;

        let file = event.target.files[0];
        if (!this.isFileSizeValid(file)) {
            this.file = undefined;
            event.target.value = '';
            this.maxSizeExceeded.emit();
        } else if (!this.isFileTypeValid(file)) {
            this.file = undefined;
            event.target.value = '';
            this.fileTypeInvalid.emit();
        } else {
            this.file = file;
            this.upload.emit(this.file);
        }
    }

    public onDragEnter() {
        this.isDragging = true;
    }

    public onDragLeave() {
        this.isDragging = false;
    }

    private isFileTypeValid(file: File) {
        let extension = this.getExtension(file);
        let acceptedFilesRegex = new RegExp(this.acceptedFileTypes.join('|'), 'i');
        return acceptedFilesRegex.test(extension);
    }

    private getExtension(file: File) {
        return '.' + file.name.split('.').pop();
    }

    private isFileSizeValid(file: File) {
        return file.size <= this.maxSize * this.byteToMo;
    }

    public reset() {
        this.file = undefined;
    }

    public validate(c: AbstractControl): { [key: string]: any; } {
        return {};
    }
    public registerOnValidatorChange?(fn: () => void): void {
        this.propagateValidatorChanged = fn;
    }
    public writeValue(obj: any): void {
        for (const file of obj) {
            this.upload.emit(file);
        }
    }
    public registerOnChange(fn: any): void {
        this.onFileChange(fn);
    }
    public registerOnTouched(fn: any): void {
        this.onFileChange(fn);
    }
    public setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/fileSelector/fileSelector.component.ts